var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serverDate)?_c('div',[_c('conditions',{attrs:{"policy":_vm.policy,"start":_vm.start,"end":_vm.end}}),_c('signature',{staticClass:"mt-3 p-1"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }